
import AP from '../config/api.config'
import store from '../store'
import PlatformLogo from '../components/common/PlatformLogo.vue'
import { fetchPublicConfig } from '../utils/publicConfig'
import { postLoginHome } from '../utils/postLoginHome'
import { ImagePreview } from 'vant'

export default {
  name: 'loginPage',
  components: { PlatformLogo },
  data () {
    return {
      phone: '',
      password: '',
      showPwd: false,
      showBusinessLicense: false,
      showUserAgreement: false,
      showPrivacyPolicy: false,
      // 平台品牌/资质：Logo 首帧即 bundle 默认（组件内降级），配置到位后无闪烁替换
      logoUrl: '',
      icpNumber: '', // ICP 备案号（publicConfig 下发，空=隐藏）
      sessionTip: '', // 会话失效统一文案（sess=expired|risk）
      profile: {},
      agreement: null,
      privacy: null
    }
  },
  computed: {
    licenseReady () {
      return !!(this.profile.businessLicenseImage || this.profile.companyName || this.profile.unifiedSocialCreditCode || this.profile.legalRepresentative)
    }
  },
  created () {
    // 会话失效回流提示（main.js 401 续期失败跳转携带；无 sess 参数不显示）
    if (this.$route.query.sess === 'expired') this.sessionTip = '登录状态已失效，请重新登录。'
    else if (this.$route.query.sess === 'risk') this.sessionTip = '检测到登录环境发生变化，请重新验证身份。'
    fetchPublicConfig().then(cfg => {
      this.logoUrl = cfg.logoUrl
      this.icpNumber = cfg.icpRecordNumber || ''
      this.profile = cfg
    })
    // 检查是否已登录
    const token = localStorage.getItem('token')
    if (token) {
      this.checkToken(token)
    }
  },
  methods: {
    // 协议/隐私按需加载：点开弹窗才拉（单次缓存），登录页首屏不下载整篇法律长文
    async openLegal (which) {
      if (!this[which]) {
        try {
          const path = which === 'agreement' ? '/legal/user-agreement' : '/legal/privacy-policy'
          const res = await this.axios.get(path)
          if (res.data.code === 200 && res.data.data) this[which] = res.data.data
        } catch (_) { /* 拉取失败保留空态 */ }
      }
      if (which === 'agreement') this.showUserAgreement = true
      else this.showPrivacyPolicy = true
    },
    viewLicense () {
      // zIndex 7000：预览可能在弹窗层内打开，默认 2000 会被压住（与 Center/SystemSetting 同规则）
      ImagePreview({ images: [this.profile.businessLicenseImage], closeable: true, loop: false, zIndex: 7000 })
    },
    toRegistered () {
      this.$router.push({ path: '/registered' })
    },
    toForgotPassword () {
      this.$router.push({ path: '/forgot-password' })
    },
    // 登录后落各自「正式主页」：口径已抽为 utils/postLoginHome（唯一真源，
    // 忘记密码重置自动登录共用同一函数，避免两处角色分支漂移）
    postLoginHome,
    async login () {
      if (!this.phone || !this.password) {
        alert('请输入账号和密码')
        return
      }

      try {
        const res = await this.axios({
          url: AP.apiList.login,
          method: 'post',
          data: { phone: this.phone, password: this.password }
        })

        if (res.data.code === 200) {
          const { token, user } = res.data.data
          // 保存token和用户信息
          localStorage.setItem('token', token)
          localStorage.setItem('user', JSON.stringify(user))
          // 同步到Vuex store
          store.commit('setUser', user)
          // 登录即拉本账号购物车角标（spec I）：clearUser 已清旧账号残留，这里补新账号真值
          store.dispatch('refreshCartCount')

          // 登录后跳转：优先 redirect 参数（守卫深链回流）；否则按角色落各自正式主页
          const redirect = this.$route.query.redirect || this.postLoginHome(user)
          this.$router.push(redirect)
        } else {
          alert(res.data.message || '登录失败')
        }
      } catch (err) {
        console.error('登录错误:', err)
        // 处理特定的状态码
        if (err.response?.status === 403) {
          alert(err.response.data.message || '账号未通过审核')
        } else if (err.response?.data?.message) {
          alert(err.response.data.message)
        } else {
          alert('登录失败，请检查网络连接')
        }
      }
    },
    async checkToken (token) {
      try {
        const res = await this.axios({
          url: AP.apiList.getUserInfo,
          method: 'get',
          headers: { Authorization: `Bearer ${token}` }
        })

        if (res.data.code === 200) {
          const user = res.data.data
          localStorage.setItem('user', JSON.stringify(user))
          // 同步到Vuex store
          store.commit('setUser', user)
          // 携有效 token 直进登录页同样要校准本账号购物车角标（与 login() 同口径，spec I）
          store.dispatch('refreshCartCount')

          // 已登录用户访问登录页：redirect 参数优先，否则同样按角色落正式主页（与 login() 同口径）
          const redirect = this.$route.query.redirect || this.postLoginHome(user)
          this.$router.push(redirect)
        }
      } catch (err) {
        // Token无效，清除
        localStorage.removeItem('token')
        localStorage.removeItem('user')
      }
    }
  }
}
